/*
 * @Description: 路由配置
 * @Author: XSYX
 * @Date: 2026-06-22 09:56:21
 * @LastEditors: XSYX
 * @LastEditTime: 2026-06-24 10:05:12
 * @FilePath: \smkp_粤河\src\router\index.js
 */
import VueRouter from "vue-router";
import Vue from "vue";
Vue.use(VueRouter);

export default new VueRouter({
  mode: "hash",
  routes: [
    {
      path: "/orderList",
      name: "orderList",
      component: () => import("../pages/orderList"),
    },
    // {
    //   path: "/",
    //   name: "home",
    //   component: () => import("../pages/home"),
    // },
    {
      path: "/",
      component: () => import("../pages/orderList"),
    },
    // {
    //   path: "/dhlr",
    //   component: () => import("../pages/dhlr/dhlr_index"),
    // },
    {
      path: "/fplr",
      component: () => import("../pages/fplr"),
    },
    {
      path: "/kpwc",
      component: () => import("../pages/kpwc"),
    },
    {
      path: "/ckfp",
      component: () => import("../pages/ckfp"),
    },
    // {
    //   path: "/sp2kp",
    //   component: () => import("../pages/sp2kp"),
    // },
    {
      path: "/error",
      component: () => import("../pages/error"),
    },
  ],
});
